import { TheMask } from 'vue-the-mask'
import countTo from 'vue-count-to'
import Info from '../components/info/info'
import Feed from '../components/feed/feed'

export default {
  TheMask,
  countTo,
  Info,
  Feed
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/resources/components.js